//import logo from './logo.svg';
import React, {useRef} from 'react';
import './App.css';
import Navbar from './Components/Navbar';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import HomePage from './Components/HomePage/HomePage';
import Blogs from './Components/HomePage/Blogs';
import FirstBlog from './Components/HomePage/firstBlog';
import SecondBlog from './Components/HomePage/SecondBlog';
import ThirdBlog from './Components/HomePage/ThirdBlog';
import FourthBlog from './Components/HomePage/FourthBlog';
import FifthBlog from './Components/HomePage/FifthBlog';
import SixthBlog from './Components/HomePage/SixthBlog';
import SeventhBlog from './Components/HomePage/SeventhBlog';
import EighthBlog from './Components/HomePage/eighthBlog';
import Work from "./Components/HomePage/Work";

function App() {
  
  const aboutRef = useRef(null);

  return (
    <>
    <Router>
      <Navbar reference={aboutRef}/>
      <div>
      <Routes>
        <Route exact path="/" element={<HomePage ref={aboutRef}/>} />
        <Route exact path="/blogs" element={<Blogs/>}/>
        <Route exact path="/blogs/The_future_of_Social_Media_Growth-How_fast-growing_startups_can_stay_ahead" element={<FirstBlog/>}/>
        <Route exact path="/blogs/Why_Content_Marketing_is_the_heart_of_Startup_Success" element={<SecondBlog/>}/>
        <Route exact path="/blogs/The_ultimate_checklist_for_building_a_brand_on_social_media" element={<ThirdBlog/>}/>
        <Route exact path="/blogs/Content_Marketing_vs_Traditional_Marketing-Why_startups_should_go_digital" element={<FourthBlog/>}/>
        <Route exact path="/blogs/How_to_leverage_Social_Media_Analytics_for_Explosive_Growth" element={<FifthBlog/>}/>
        <Route exact path="/blogs/The_role_of_AI_in_Next-Gen_Content_Marketing-A_startup's_guide" element={<SixthBlog/>}/>
        <Route exact path="/blogs/Building_global_brands_with_local_appeal-Strategies_for_startups" element={<SeventhBlog/>}/>
        <Route exact path="/blogs/Hypercontent’s_Playbook_for_viral_social_media_campaigns" element={<EighthBlog/>}/>
        <Route exact path="/work" element={<Work/>}/>
      </Routes>
      </div>
    </Router>
    </>
  );
}

export default App;


/*import React from 'react'

function $1() {
  return <div>$0</div>
}

export default $1*/




